export default __webpack_public_path__ + "static/media/poster_jewelry.15365b47.jpg";